// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.disabled {\n  background: #c9cace !important;\n  pointer-events: none;\n}\n.centerBox {\n  cursor: pointer;\n  transition: 0.2s all;\n}\n.centerBox:hover {\n  opacity: 0.9;\n}\n.btn-add {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n}\n", ""]);
// Exports
module.exports = exports;
